<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <div v-on="on" class="name-style">
        <a @click="onClick">
          {{ insertionOrderName }}
        </a>
      </div>
    </template>
    <span>
      {{ insertionOrderName }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'MapReportRequestListInsertionOrderName',
  props: {
    insertionOrderId: {
      type: Number,
      required: true,
    },
    insertionOrderName: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      const { agencyId, advertiserId } = this.$route.params
      const location = `/agencies/${agencyId}/advertisers/${advertiserId}/insertion_orders?id=${this.insertionOrderId}`
      this.$router.push(location).catch(() => {})
    },
  },
}
</script>

<style scoped>
.name-style {
  flex: 1;
  max-width: 300px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
